module.exports = __webpack_public_path__ + "img/fruit-oranges-350x184.61e6237b.jpg";